<template>
  <div  class="Loadingbox">
    <van-loading class="loading" type="spinner" vertical color="#666666">
    加载中...
    </van-loading>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.Loadingbox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90vh;
  width: 100vw;
}
</style>